(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredient-carousel')) {
    customElements.define(
      'ingredient-carousel',
      class IngredientCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
          this.details = Array.from(this.querySelectorAll('[data-carousel-detail]'));
          this.current = this.querySelector('[data-carousel-current]');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');
          this.slidesContainer = this.querySelector('[data-carousel-slides]');
          this.activeIndex = Math.max(
            0,
            this.slides.findIndex((slide) => slide.classList.contains('is-active'))
          );

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
          this.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.move(-1);
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.move(1);
            }
          });

          this.addEventListener('shopify:block:select', (event) => {
            const selectedSlide = event.target.closest('[data-carousel-slide]');
            if (selectedSlide) {
              this.show(Number(selectedSlide.dataset.index), true);
            }
          });

          const usesAdaptiveMedia = this.classList.contains('ingredient-carousel--ratio-adapt');
          const usesAdaptiveSectionHeight =
            this.classList.contains('ingredient-carousel--height-desktop-adapt') ||
            this.classList.contains('ingredient-carousel--height-mobile-adapt');

          if (usesAdaptiveMedia || usesAdaptiveSectionHeight) {
            this.resizeObserver = new ResizeObserver(() => {
              this.syncActiveHeight();
              this.syncSectionHeight();
            });
            this.resizeObserver.observe(this);
            this.querySelectorAll('img').forEach((image) => {
              image.addEventListener(
                'load',
                () => {
                  this.syncActiveHeight();
                  this.syncSectionHeight();
                },
                { once: true }
              );
            });
          }

          this.show(this.activeIndex, false);
          this.syncSectionHeight();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          clearTimeout(this.animationTimer);
        }

        move(direction) {
          if (this.slides.length < 2) return;
          this.show((this.activeIndex + direction + this.slides.length) % this.slides.length, true);
        }

        show(index, animate = true) {
          const count = this.slides.length;
          if (!count) return;

          this.activeIndex = (index + count) % count;

          this.slides.forEach((slide, slideIndex) => {
            const distance = (slideIndex - this.activeIndex + count) % count;
            const isActive = distance === 0;
            const isNext = distance === 1;
            const isPrevious = count > 2 && distance === count - 1;

            slide.classList.toggle('is-active', isActive);
            slide.classList.toggle('is-next', isNext);
            slide.classList.toggle('is-previous', isPrevious);
            slide.setAttribute('aria-hidden', String(!isActive));
          });

          this.details.forEach((detail, detailIndex) => {
            const isActive = detailIndex === this.activeIndex;
            detail.classList.toggle('is-active', isActive);
            detail.hidden = !isActive;
          });

          if (this.current) {
            this.current.textContent = String(this.activeIndex + 1);
          }

          if (animate && !this.classList.contains('ingredient-carousel--animation-none')) {
            this.restartAnimation();
          }

          this.syncActiveHeight();
        }

        restartAnimation() {
          clearTimeout(this.animationTimer);
          this.classList.remove('is-animating');
          void this.offsetWidth;
          this.classList.add('is-animating');
          this.animationTimer = window.setTimeout(() => {
            this.classList.remove('is-animating');
          }, Number(this.dataset.animationDuration) || 600);
        }

        syncActiveHeight() {
          if (!this.classList.contains('ingredient-carousel--ratio-adapt') || !this.slidesContainer) return;

          requestAnimationFrame(() => {
            const activeMedia = this.slides[this.activeIndex]?.querySelector('.ingredient-carousel__media');
            if (activeMedia?.offsetHeight) {
              this.style.setProperty('--ingredient-adapt-height', `${activeMedia.offsetHeight}px`);
            }
          });
        }

        syncSectionHeight() {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const usesAdaptiveHeight = isMobile
            ? this.classList.contains('ingredient-carousel--height-mobile-adapt')
            : this.classList.contains('ingredient-carousel--height-desktop-adapt');

          if (!usesAdaptiveHeight) {
            this.style.removeProperty('--ingredient-computed-height');
            return;
          }

          const ratio = Number(
            isMobile ? this.dataset.backgroundRatioMobile : this.dataset.backgroundRatioDesktop
          );
          const scale =
            Number(
              isMobile
                ? this.dataset.backgroundHeightScaleMobile
                : this.dataset.backgroundHeightScaleDesktop
            ) / 100;
          const maximumHeight = Number(
            isMobile
              ? this.dataset.backgroundMaxHeightMobile
              : this.dataset.backgroundMaxHeightDesktop
          );
          const width = this.getBoundingClientRect().width;

          if (!ratio || !width) return;

          const imageHeight = Math.round((width / ratio) * scale);
          const computedHeight = maximumHeight ? Math.min(imageHeight, maximumHeight) : imageHeight;
          if (computedHeight === this.computedSectionHeight) return;

          this.computedSectionHeight = computedHeight;
          this.style.setProperty('--ingredient-computed-height', `${computedHeight}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purposeful-ingredients"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.carouselInitialized === 'true') return;
      const track = root.querySelector('[data-carousel-track]');
      const slides = Array.from(root.querySelectorAll('[data-carousel-slide]'));
      const previous = root.querySelector('[data-carousel-previous]');
      const next = root.querySelector('[data-carousel-next]');
      const dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));
      if (!track || slides.length < 2) return;

      root.dataset.carouselInitialized = 'true';
      let activeIndex = 0;
      let frame;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;

      const normalizeIndex = (index) => {
        if (index < 0) return slides.length - 1;
        if (index >= slides.length) return 0;
        return index;
      };

      const setActive = (index) => {
        activeIndex = normalizeIndex(index);
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const scrollToSlide = (index) => {
        const targetIndex = normalizeIndex(index);
        slides[targetIndex]?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
        setActive(targetIndex);
      };

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          const trackLeft = track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          setActive(closestIndex);
        });
      }, { passive: true });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollToSlide(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollToSlide(activeIndex + 1);
        }
      });

      previous?.addEventListener('click', () => scrollToSlide(activeIndex - 1));
      next?.addEventListener('click', () => scrollToSlide(activeIndex + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => scrollToSlide(Number(dot.dataset.carouselDot)));
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        isDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 4) dragMoved = true;
        track.scrollLeft = dragStartScroll - distance;
      });

      track.addEventListener('pointerup', (event) => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        track.releasePointerCapture(event.pointerId);
        if (dragMoved) {
          window.requestAnimationFrame(() => scrollToSlide(activeIndex));
        }
      });

      track.addEventListener('pointercancel', () => {
        isDragging = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      setActive(0);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-purposeful-ingredients]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-purposeful-ingredients]');
      const slide = event.target.closest('[data-carousel-slide]');
      if (!root || !slide) return;
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-video-stories')) {
    customElements.define(
      'ugc-video-stories',
      class UgcVideoStories extends HTMLElement {
        connectedCallback() {
          if (this.isConnectedToVideoStories) return;

          this.isConnectedToVideoStories = true;
          this.track = this.querySelector('[data-video-track]');
          this.cards = Array.from(this.querySelectorAll('[data-video-card]:not([data-carousel-clone])'));
          this.loopEnabled = this.cards.length > 1;
          this.cards.forEach((card, index) => {
            card.dataset.logicalIndex = String(index);
          });
          this.setupLoopCards();
          this.navigation = this.querySelector('[data-video-navigation]');
          this.previousButton = this.querySelector('[data-video-previous]');
          this.nextButton = this.querySelector('[data-video-next]');
          this.dots = Array.from(this.querySelectorAll('[data-video-dot]'));
          this.dialog = this.querySelector('[data-video-dialog]');
          this.dialogContent = this.querySelector('[data-video-dialog-content]');
          this.closeButton = this.querySelector('[data-video-close]');
          this.activeIndex = 0;
          this.physicalIndex = this.loopEnabled ? this.cards.length : 0;
          this.visibleAutoplayMedia = new Set();
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.mobileMedia = window.matchMedia('(max-width: 749px)');
          this.pointerId = undefined;
          this.pointerDown = false;
          this.isDragging = false;
          this.suppressClick = false;

          this.handleClick = this.handleClick.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handlePointerDown = this.handlePointerDown.bind(this);
          this.handlePointerMove = this.handlePointerMove.bind(this);
          this.handlePointerUp = this.handlePointerUp.bind(this);
          this.handlePointerCancel = this.handlePointerCancel.bind(this);
          this.handlePointerLeave = this.handlePointerLeave.bind(this);
          this.handleNativeDragStart = this.handleNativeDragStart.bind(this);
          this.handleDialogClick = this.handleDialogClick.bind(this);
          this.handleDialogClose = this.handleDialogClose.bind(this);
          this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.addEventListener('click', this.handleClick);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          window.addEventListener('resize', this.handleResize, { passive: true });
          document.addEventListener('visibilitychange', this.handleVisibilityChange);

          if (this.track) {
            this.track.addEventListener('scroll', this.handleScroll, { passive: true });
            this.track.addEventListener('keydown', this.handleKeydown);
            this.track.addEventListener('pointerdown', this.handlePointerDown);
            this.track.addEventListener('pointermove', this.handlePointerMove, { passive: false });
            this.track.addEventListener('pointerup', this.handlePointerUp);
            this.track.addEventListener('pointercancel', this.handlePointerCancel);
            this.track.addEventListener('pointerleave', this.handlePointerLeave);
            this.track.addEventListener('dragstart', this.handleNativeDragStart);
          }

          if (this.dialog) {
            this.dialog.addEventListener('click', this.handleDialogClick);
            this.dialog.addEventListener('close', this.handleDialogClose);
          }

          if ('IntersectionObserver' in window && !this.reduceMotion) {
            this.autoplayObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this.visibleAutoplayMedia.add(entry.target);
                    if (!this.dialog?.open && !document.hidden) this.startAutoplay(entry.target);
                  } else {
                    this.visibleAutoplayMedia.delete(entry.target);
                    this.stopAutoplay(entry.target);
                  }
                });
              },
              { threshold: 0.45 }
            );

            this.cards.forEach((card) => {
              card.querySelectorAll('[data-autoplay-video], [data-inline-autoplay]').forEach((media) => {
                this.autoplayObserver.observe(media);
              });
            });
          }

          requestAnimationFrame(() => {
            this.jumpToPhysicalIndex(this.physicalIndex);
            this.updateSliderState();
            this.updateQuoteToggles();
          });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          window.removeEventListener('resize', this.handleResize);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          this.track?.removeEventListener('scroll', this.handleScroll);
          this.track?.removeEventListener('keydown', this.handleKeydown);
          this.track?.removeEventListener('pointerdown', this.handlePointerDown);
          this.track?.removeEventListener('pointermove', this.handlePointerMove);
          this.track?.removeEventListener('pointerup', this.handlePointerUp);
          this.track?.removeEventListener('pointercancel', this.handlePointerCancel);
          this.track?.removeEventListener('pointerleave', this.handlePointerLeave);
          this.track?.removeEventListener('dragstart', this.handleNativeDragStart);
          this.dialog?.removeEventListener('click', this.handleDialogClick);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
          this.autoplayObserver?.disconnect();
          cancelAnimationFrame(this.scrollFrame);
          cancelAnimationFrame(this.resizeFrame);
          clearTimeout(this.scrollSettleTimer);
          clearTimeout(this.manualSettleTimer);
          clearTimeout(this.suppressClickTimer);
          this.track?.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
          this.isConnectedToVideoStories = false;
        }

        handleClick(event) {
          if (this.suppressClick) {
            event.preventDefault();
            event.stopPropagation();
            this.suppressClick = false;
            return;
          }

          const quoteToggle = event.target.closest('[data-quote-toggle]');
          if (quoteToggle) {
            this.toggleQuote(quoteToggle);
            return;
          }

          const opener = event.target.closest('[data-video-open]');
          if (opener && !opener.disabled) {
            this.openDialog(opener);
            return;
          }

          const dot = event.target.closest('[data-video-dot]');
          if (dot) {
            this.scrollToCard(Number(dot.dataset.index));
            return;
          }

          if (event.target.closest('[data-video-previous]')) {
            this.stepBy(-1);
            return;
          }

          if (event.target.closest('[data-video-next]')) {
            this.stepBy(1);
            return;
          }

          if (event.target.closest('[data-video-close]')) this.closeDialog();
        }

        handleScroll() {
          if (this.programmaticTarget !== undefined) return;

          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateSliderState());
          clearTimeout(this.manualSettleTimer);
          this.manualSettleTimer = setTimeout(() => {
            if (!this.isDragging) this.normalizeLoopPosition();
          }, 140);
        }

        handleResize() {
          this.programmaticTarget = undefined;
          clearTimeout(this.scrollSettleTimer);
          clearTimeout(this.manualSettleTimer);
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            this.physicalIndex = this.loopEnabled ? this.cards.length + this.activeIndex : this.activeIndex;
            this.jumpToPhysicalIndex(this.physicalIndex);
            this.updateSliderState();
            this.updateQuoteToggles();
          });
        }

        updateQuoteToggles() {
          this.querySelectorAll('[data-quote-wrap]').forEach((wrap) => {
            const quote = wrap.querySelector('[data-card-quote]');
            const toggle = wrap.querySelector('[data-quote-toggle]');
            if (!quote || !toggle) return;

            if (wrap.classList.contains('is-expanded')) {
              toggle.hidden = false;
              return;
            }

            toggle.hidden = quote.scrollHeight <= quote.clientHeight + 1;
          });
        }

        toggleQuote(toggle) {
          const wrap = toggle.closest('[data-quote-wrap]');
          const label = toggle.querySelector('[data-quote-toggle-label]');
          if (!wrap || !label) return;

          const shouldExpand = toggle.getAttribute('aria-expanded') !== 'true';
          wrap.classList.toggle('is-expanded', shouldExpand);
          toggle.setAttribute('aria-expanded', String(shouldExpand));
          label.textContent = shouldExpand ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
          requestAnimationFrame(() => this.updateSliderState());
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.stepBy(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepBy(1);
          }
        }

        handlePointerDown(event) {
          if (!this.track || event.pointerType !== 'mouse' || event.button !== 0) return;

          this.pointerId = event.pointerId;
          this.pointerDown = true;
          this.isDragging = false;
          this.dragStartX = event.clientX;
          this.dragStartScrollLeft = this.track.scrollLeft;
          this.programmaticTarget = undefined;
          clearTimeout(this.scrollSettleTimer);
          clearTimeout(this.manualSettleTimer);
        }

        handlePointerMove(event) {
          if (!this.track || !this.pointerDown || event.pointerId !== this.pointerId) return;

          const distance = event.clientX - this.dragStartX;
          if (!this.isDragging && Math.abs(distance) < 6) return;

          if (!this.isDragging) {
            this.isDragging = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture?.(event.pointerId);
          }

          event.preventDefault();
          this.track.scrollLeft = this.dragStartScrollLeft - distance;
        }

        handlePointerUp(event) {
          this.finishPointerInteraction(event, false);
        }

        handlePointerCancel(event) {
          this.finishPointerInteraction(event, true);
        }

        handlePointerLeave(event) {
          if (this.pointerDown && !this.isDragging && event.pointerId === this.pointerId) {
            this.pointerDown = false;
            this.pointerId = undefined;
          }
        }

        handleNativeDragStart(event) {
          event.preventDefault();
        }

        finishPointerInteraction(event, cancelled) {
          if (!this.track || !this.pointerDown || event.pointerId !== this.pointerId) return;

          const wasDragging = this.isDragging;
          if (this.track.hasPointerCapture?.(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }

          this.pointerDown = false;
          this.pointerId = undefined;
          this.isDragging = false;
          this.track.classList.remove('is-dragging');

          if (!wasDragging) return;

          if (!cancelled) {
            this.suppressClick = true;
            clearTimeout(this.suppressClickTimer);
            this.suppressClickTimer = setTimeout(() => {
              this.suppressClick = false;
            }, 120);
          }

          requestAnimationFrame(() => this.snapToClosestCard());
        }

        handleDialogClick(event) {
          if (event.target === this.dialog) this.closeDialog();
        }

        handleDialogClose() {
          this.dialogContent?.replaceChildren();
          document.documentElement.style.overflow = this.previousDocumentOverflow || '';
          this.visibleAutoplayMedia.forEach((media) => this.startAutoplay(media));
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.visibleAutoplayMedia.forEach((media) => this.stopAutoplay(media));
          } else if (!this.dialog?.open) {
            this.visibleAutoplayMedia.forEach((media) => this.startAutoplay(media));
          }
        }

        handleBlockSelect(event) {
          const card = event.target.closest('[data-video-card]');
          if (!card) return;

          const index = this.cards.indexOf(card);
          if (index >= 0) this.scrollToCard(index);
        }

        setupLoopCards() {
          if (!this.track || !this.loopEnabled) {
            this.allCards = this.cards;
            return;
          }

          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();

          this.cards.forEach((card, index) => {
            before.append(this.createLoopClone(card, index));
            after.append(this.createLoopClone(card, index));
          });

          this.track.prepend(before);
          this.track.append(after);
          this.allCards = Array.from(this.track.querySelectorAll('[data-video-card]'));
        }

        createLoopClone(card, logicalIndex) {
          const clone = card.cloneNode(true);
          clone.dataset.carouselClone = '';
          clone.dataset.logicalIndex = String(logicalIndex);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          clone.removeAttribute('data-block-id');

          Array.from(clone.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) clone.removeAttribute(attribute.name);
          });

          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          clone.querySelectorAll('a, button, input, select, textarea, video, iframe').forEach((element) => {
            element.setAttribute('tabindex', '-1');
            if (element instanceof HTMLVideoElement) {
              element.pause();
              element.removeAttribute('autoplay');
            }
          });

          return clone;
        }

        getCardScrollLeft(card) {
          const startPosition = card.offsetLeft - this.track.offsetLeft;
          return this.mobileMedia.matches
            ? startPosition
            : startPosition - (this.track.clientWidth - card.offsetWidth) / 2;
        }

        jumpToPhysicalIndex(index) {
          const card = this.allCards?.[index];
          if (!this.track || !card) return;

          const previousBehavior = this.track.style.scrollBehavior;
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft = this.getCardScrollLeft(card);
          this.track.style.scrollBehavior = previousBehavior;
          this.physicalIndex = index;
        }

        normalizeLoopPosition() {
          if (!this.loopEnabled) return;

          const count = this.cards.length;
          let normalizedIndex = this.physicalIndex;
          if (normalizedIndex < count) normalizedIndex += count;
          if (normalizedIndex >= count * 2) normalizedIndex -= count;

          if (normalizedIndex !== this.physicalIndex) this.jumpToPhysicalIndex(normalizedIndex);
        }

        getClosestPhysicalIndex() {
          if (!this.track || !this.allCards?.length) return 0;

          const trackRect = this.track.getBoundingClientRect();
          const trackAnchor = this.mobileMedia.matches ? trackRect.left : trackRect.left + trackRect.width / 2;
          let closestPhysicalIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.allCards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardAnchor = this.mobileMedia.matches ? cardRect.left : cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardAnchor - trackAnchor);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestPhysicalIndex = index;
            }
          });

          return closestPhysicalIndex;
        }

        snapToClosestCard() {
          if (!this.track || !this.allCards?.length) return;

          const closestPhysicalIndex = this.getClosestPhysicalIndex();
          const logicalIndex = Number(this.allCards[closestPhysicalIndex].dataset.logicalIndex);
          this.scrollToPhysicalIndex(closestPhysicalIndex, logicalIndex);
        }

        updateSliderState() {
          if (!this.track || this.cards.length === 0) return;

          const closestPhysicalIndex = this.getClosestPhysicalIndex();

          this.physicalIndex = closestPhysicalIndex;
          this.setActiveIndex(Number(this.allCards[closestPhysicalIndex].dataset.logicalIndex));

          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
          const controlsDisabled = !hasOverflow || this.cards.length < 2;
          if (this.navigation) this.navigation.hidden = controlsDisabled;
          if (this.previousButton) this.previousButton.disabled = controlsDisabled;
          if (this.nextButton) this.nextButton.disabled = controlsDisabled;
        }

        setActiveIndex(index) {
          this.activeIndex = index;
          this.dots.forEach((dot, index) => {
            const isActive = index === this.activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        scrollToCard(index) {
          if (!this.track || this.cards.length === 0) return;

          const logicalIndex = ((index % this.cards.length) + this.cards.length) % this.cards.length;
          const physicalIndex = this.loopEnabled ? this.cards.length + logicalIndex : logicalIndex;
          this.scrollToPhysicalIndex(physicalIndex, logicalIndex);
        }

        stepBy(direction) {
          if (!this.track || this.cards.length < 2) return;

          if (this.physicalIndex <= 0 || this.physicalIndex >= this.allCards.length - 1) {
            this.physicalIndex = this.cards.length + this.activeIndex;
            this.jumpToPhysicalIndex(this.physicalIndex);
          }

          const logicalIndex =
            ((this.activeIndex + direction) % this.cards.length + this.cards.length) % this.cards.length;
          this.scrollToPhysicalIndex(this.physicalIndex + direction, logicalIndex);
        }

        scrollToPhysicalIndex(physicalIndex, logicalIndex) {
          const card = this.allCards[physicalIndex];
          if (!card) return;

          this.programmaticTarget = physicalIndex;
          this.physicalIndex = physicalIndex;
          this.setActiveIndex(logicalIndex);
          this.track.scrollTo({
            left: this.getCardScrollLeft(card),
            behavior: this.reduceMotion ? 'auto' : 'smooth'
          });
          clearTimeout(this.scrollSettleTimer);
          this.scrollSettleTimer = setTimeout(
            () => {
              this.physicalIndex = physicalIndex;
              this.normalizeLoopPosition();
              this.programmaticTarget = undefined;
              this.updateSliderState();
            },
            this.reduceMotion ? 0 : 500
          );
        }

        openDialog(opener) {
          if (!this.dialog || !this.dialogContent) return;

          const template = this.querySelector(`#${CSS.escape(opener.dataset.videoTemplate)}`);
          if (!template) return;

          this.visibleAutoplayMedia.forEach((media) => this.stopAutoplay(media));
          this.dialogContent.replaceChildren(template.content.cloneNode(true));
          this.previousDocumentOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';

          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }

          this.dialogContent.querySelector('video')?.play().catch(() => {});
        }

        closeDialog() {
          if (!this.dialog) return;

          if (typeof this.dialog.close === 'function') {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
            this.handleDialogClose();
          }
        }

        startAutoplay(media) {
          if (this.reduceMotion || document.hidden) return;

          if (media.matches('[data-autoplay-video]')) {
            media.play().catch(() => {});
            return;
          }

          const template = media.querySelector('[data-inline-template]');
          const host = media.querySelector('[data-inline-host]');
          if (template && host && host.childElementCount === 0) {
            host.append(template.content.cloneNode(true));
          }
        }

        stopAutoplay(media) {
          if (media.matches('[data-autoplay-video]')) {
            media.pause();
            return;
          }

          media.querySelector('[data-inline-host]')?.replaceChildren();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
